import { render, staticRenderFns } from "./editApprove.vue?vue&type=template&id=a5fb3f34&scoped=true"
import script from "./editApprove.vue?vue&type=script&lang=js"
export * from "./editApprove.vue?vue&type=script&lang=js"
import style0 from "./editApprove.vue?vue&type=style&index=0&id=a5fb3f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fb3f34",
  null
  
)

export default component.exports